// Компонент — из "antd", а не из "antd/lib": CJS-сборка держит свой DisabledContext,
// и disabled формы до поля не доходит.
import { Input } from "antd";
import type { TextAreaProps } from "antd/es/input";
import { AiManipulateTextButton } from "@/modules/ai/features/manipulate-text";
import { twMerge } from "tailwind-merge";

export function TextArea({
  value,
  onChange,
  className,
  withoutAI,
  ...rest
}: Omit<TextAreaProps, "value" | "onChange"> & {
  value?: string;
  onChange?: (value: string) => void;
  withoutAI?: boolean;
}) {
  return (
    <div className={"relative"}>
      <Input.TextArea
        className={twMerge("pr-7", className)}
        value={value}
        onChange={(e) => onChange?.(e.target.value)}
        {...rest}
      />

      {!withoutAI && (
        <div className={"absolute right-1 top-1"}>
          <AiManipulateTextButton value={value} setValue={onChange} />
        </div>
      )}
    </div>
  );
}
